import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const fetchSeverityRule = (customer, id) => {
  return axios({
    url: `/rule/${customer}/${id}`,
    method: 'get'
  });
};

const useGetSeverityRule = (customer, id) => {
  return useQuery(
    ['severity_rule', customer, id],
    () => fetchSeverityRule(customer, id),
    {
      enabled: !!customer && !!id
    }
  );
};

export default useGetSeverityRule;
